import IconController from '../../containers/iconController';
import { config } from '../../../config/Constants';
import React, { useEffect, useState } from 'react';
import DefaultWidgetBody from './DefaultWidgetBody';
import RotatingWidgetBody, { buildRotationItems } from './RotatingWidgetBody';
import { getWidgetLayoutVariant } from './widgetLayout';
import Cookies from 'js-cookie';
import Axios from 'axios';
import "./widget.css";  

const ROTATION_INTERVAL = 3000;
const ROTATING_WIDGET_COLORS = ['#D7F0E3', '#DCEBFF', '#FBE0D0', '#EDE2FF', '#F8EDC9'];

const Widget = ({ type, onLayoutChange }) => {
  const [widgetDetails, setWidgetDetails] = useState();
  const [widgetData, setWidgetData] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);

  const widgetType = widgetDetails?.TYPE?.toUpperCase();
  const rotationItems = widgetType === 'ROTATING' ? buildRotationItems(widgetData) : [];
  const layoutVariant = getWidgetLayoutVariant(widgetDetails, widgetData);
  const rotatingBackgroundColor = rotationItems.length > 0
    ? ROTATING_WIDGET_COLORS[activeIndex % ROTATING_WIDGET_COLORS.length]
    : null;

  const widgetStyle = {
    backgroundColor: rotatingBackgroundColor || (widgetDetails && widgetDetails.WIDGET_COLOR) || '#FFFFFF'
  };  

  useEffect(() => {
    const companyName = Cookies.get('cp-cn');

    const getWidgetDetails = async () => {
      const response = await Axios.get(config.url.GET_WIDGET_DETAILS, {
        params: { widgetId: type.widgetId }
      });
      setWidgetDetails(response.data.widgetDetails[0]);
    };

    const getWidgetData = async () => {
      const response = await Axios.get(config.url.GET_WIDGET_DATA, {
        params: {
          widgetId: type.widgetId,
          companyName: companyName,
          carrier: type.carrier,
        }
      });
      setWidgetData(response.data.widgetValue || {});
    };

    getWidgetDetails();
    getWidgetData();
  }, [type.widgetId, type.carrier]);

  useEffect(() => {
    setActiveIndex(0);
  }, [widgetData, widgetType]);

  useEffect(() => {
    if (onLayoutChange) {
      onLayoutChange(type.widgetId, layoutVariant);
    }
  }, [layoutVariant, onLayoutChange, type.widgetId]);

  useEffect(() => {
    if (widgetType !== 'ROTATING' || rotationItems.length <= 1) {
      return undefined;
    }

    const intervalId = setInterval(() => {
      setActiveIndex((currentIndex) => (currentIndex + 1) % rotationItems.length);
    }, ROTATION_INTERVAL);

    return () => clearInterval(intervalId);
  }, [rotationItems.length, widgetType]);

  const renderWidgetBody = () => {
    if (widgetType === 'ROTATING') {
      return (
        <RotatingWidgetBody
          rotationItems={rotationItems}
          activeIndex={activeIndex}
        />
      );
    }

    return <DefaultWidgetBody widgetData={widgetData} />;
  };

  return (
    <div className="widget" style={widgetStyle}>
      <div className="widgetPageContent">
        <div className="leftWidget">
          {widgetDetails && (
            <div className="widgetIcon">
              <IconController iconType={widgetDetails.WIDGET_ICON} />
            </div>
          )}
        </div>
        <div className="rightWidget">
          <div className="widgetTop">
            {widgetDetails && (
              <div className="widgetTitle">
                {widgetDetails.WIDGET_NAME}
              </div>
            )}
          </div>
          <div className="widgetBody">
            {renderWidgetBody()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Widget;
